import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import classnames from 'classnames';
import { findDOMNode } from 'react-dom';

class RadioButton extends Component {
  static displayName = 'RadioButton';

  static propTypes = {
    checked: PropTypes.bool,
    className: PropTypes.string,
    name: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    value: PropTypes.string.isRequired,
    description: PropTypes.string,
    isTextBold: PropTypes.bool,
    checkboxClick: PropTypes.func
  };

  @autobind
  handleClick(event) {
    if (this.props.onClick) {
      var radioInput = findDOMNode(this.refs.radioInput);
      this.props.onClick(radioInput.value, event);
    }
  }

  @autobind
  checkboxClick(event) {
    if (this.props.checkboxClick) {
      var radioInput = findDOMNode(this.refs.radioInput);
      this.props.checkboxClick(radioInput.value, event);
    }
  }

  render() {
    var { checked, description, className, name, text, value, isTextBold } = this.props;
    className = classnames('label-box', className, {
      checked: checked,
      description: description
    });

    var descriptionComponent = null;
    if (description) {
      descriptionComponent = <label className="description">{description}</label>;
    }
    var textStyle = {};
    if (isTextBold) {
      textStyle.fontWeight = 700;
    }

    return (
      <div className={className} onClick={this.handleClick}>
        <span className="radio" onClick={this.checkboxClick}>
          <input ref="radioInput" type="radio" name={name} value={value} />
        </span>
        <label className="text" style={textStyle}>
          {text}
        </label>{' '}
        {descriptionComponent}
      </div>
    );
  }
}

export default RadioButton;
